import { Modal, Text } from '@shopify/polaris';
import { SettingsDependencyBanner } from './SettingsDependencyBanner';
import {
  presentChangeKind,
  presentSettingsPreviewFieldLabel,
  presentSettingsTarget,
  presentSettingsValue,
} from '../lib/settingsPresentation';

export function ConfirmApplyModal({
  open,
  title,
  previews,
  busy,
  onClose,
  onConfirm,
}: {
  open: boolean;
  title: string;
  previews: any[];
  busy?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      primaryAction={{
        content: busy ? 'Застосовую...' : 'Підтвердити',
        onAction: onConfirm,
        loading: Boolean(busy),
      }}
      secondaryActions={[{ content: 'Скасувати', onAction: onClose }]}
    >
      <Modal.Section>
        <div className="admin-stack">
          {previews.map((preview) => (
            <div key={`${preview.target}-${preview.revision}`} className="admin-stack admin-stack--tight">
              <Text as="h3" variant="headingMd">{presentSettingsTarget(preview.target)}</Text>
              <SettingsDependencyBanner errors={preview.errors || []} warnings={preview.warnings || []} />
              <div className="admin-table-wrap">
                <table className="admin-table">
                  <thead>
                    <tr>
                      <th>Поле</th>
                      <th>Було</th>
                      <th>Стане</th>
                      <th>Тип зміни</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(preview.diff || []).map((entry: any) => (
                      <tr key={`${preview.target}-${entry.key}`}>
                        <td>{presentSettingsPreviewFieldLabel(entry)}</td>
                        <td>{presentSettingsValue(entry.currentValue)}</td>
                        <td>{presentSettingsValue(entry.nextValue)}</td>
                        <td>{presentChangeKind(Boolean(entry.linked))}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      </Modal.Section>
    </Modal>
  );
}
